import {
    ACCESS_TKN_KEY,
    GRAPH_TOKEN,
    StorageService,
} from '../services/storage_service';
import { isJwtExpired } from './isJwtExpired.helper';
import { acquireAccessToken, acquireGraphToken } from '../auth/msal';

export const validateTokens = async () => {
    let accessToken = StorageService.getItem(ACCESS_TKN_KEY);
    let graphToken = StorageService.getItem(GRAPH_TOKEN);

    if (!isJwtExpired(accessToken) && !isJwtExpired(graphToken)) {
        return {
            accessToken,
            graphToken,
        };
    }

    try {
        if (isJwtExpired(accessToken)) {
            // request for new access token
            const tokenResponse: any = await acquireAccessToken();
            accessToken = tokenResponse.accessToken;
            StorageService.setItem(ACCESS_TKN_KEY, accessToken);
        }
        if (isJwtExpired(graphToken)) {
            // request for new graph token
            const graphApiResponse: any = await acquireGraphToken();
            graphToken = graphApiResponse.accessToken;
            StorageService.setItem(GRAPH_TOKEN, graphToken);
        }

        return {
            accessToken,
            graphToken,
        };
    } catch (error: any) {
        // Handle refresh token expiration
        if (error?.errorCode === 'invalid_grant' || 
            error?.message?.includes('AADSTS700084')) {
            
            // Clear all storage and redirect to login
            StorageService.clear();
            sessionStorage.clear();
            
            // Force page reload to trigger re-authentication
            window.location.reload();
            
            throw new Error('Refresh token expired, redirecting to login');
        }
        throw error;
    }
};

export const isTokenExpired = () => {
    const accessToken = StorageService.getItem(ACCESS_TKN_KEY);
    const graphToken = StorageService.getItem(GRAPH_TOKEN);

    return isJwtExpired(accessToken) || isJwtExpired(graphToken);
}